var VolumeTypes = {
  PERSISTENT: "Persistent",
  EXTERNAL: "External"
};

module.exports = VolumeTypes;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/VolumeTypes.js